{
  "title": "Alerts",
  "subtitle": "Problems the system noticed for you. Most alerts close by themselves once the problem is fixed.",
  "markAllRead": "Mark all as read",
  "markAllReadShort": "Mark all read",
  "markRead": "Mark as read",
  "allMarked": "All alerts are marked as read.",
  "tabs": {
    "new": "New",
    "read": "Read",
    "resolved": "Resolved",
    "all": "All"
  },
  "filters": {
    "type": "Type",
    "allTypes": "All types",
    "location": "Location"
  },
  "groups": {
    "new": "New · {{count}}",
    "earlier": "Earlier",
    "seeAll": "See all alerts"
  },
  "state": {
    "new": "New",
    "read": "Read",
    "resolved": "Resolved"
  },
  "inTotal": "All locations",
  "loadMore": "Show more",
  "empty": {
    "new": "You are all caught up",
    "read": "No alert read and still open",
    "resolved": "No resolved alert yet",
    "all": "No alert yet",
    "text": "Alerts appear here when stock runs low, goes out or below zero, a transfer is late, or a count differs too much."
  },
  "types": {
    "negative_stock": "Negative stock",
    "large_adjustment": "Large adjustment",
    "low_stock": "Low stock",
    "transfer_delayed": "Transfer delayed",
    "out_of_stock": "Out of stock",
    "count_variance": "Count variance",
    "overstock": "Overstock",
    "job_failed": "Import or backup failed",
    "order_to_prepare": "Order to prepare",
    "cod_overdue": "Cash on delivery not settled",
    "shift_open_late": "Shift still open",
    "cash_variance": "Cash variance"
  },
  "short": {
    "negative_stock": "Negative",
    "large_adjustment": "Approval",
    "low_stock": "Low",
    "transfer_delayed": "Delayed",
    "out_of_stock": "Out",
    "count_variance": "Variance",
    "overstock": "Overstock",
    "job_failed": "Failed",
    "order_to_prepare": "Order",
    "cod_overdue": "COD",
    "shift_open_late": "Open",
    "cash_variance": "Variance"
  },
  "text": {
    "negative_stock": {
      "title": "{{product}} is at {{quantity}}",
      "confirmed": "{{person}} confirmed it.",
      "detail": "Count the shelf or record the missing receipt to bring it back to zero or more."
    },
    "large_adjustment": {
      "title": "{{number}} needs a manager to validate it",
      "detail": "Worth {{value}} TND, above the {{limit}} TND approval limit.",
      "detailBy": "Submitted by {{person}}. Worth {{value}} TND, above the {{limit}} TND approval limit."
    },
    "low_stock": {
      "title": "{{product}} is running low",
      "detail": "{{quantity}} left. The minimum for this location is {{min}}.",
      "detailTotal": "{{quantity}} left in total. The minimum is {{min}}."
    },
    "transfer_delayed": {
      "title_one": "{{number}} is not fully received after {{count}} day",
      "title_other": "{{number}} is not fully received after {{count}} days",
      "detail_one": "Sent on {{date}}. Transfers should be received within {{count}} day.",
      "detail_other": "Sent on {{date}}. Transfers should be received within {{count}} days."
    },
    "out_of_stock": {
      "title": "{{product}} is out of stock",
      "detail": "Nothing left in {{place}}. {{elsewhere}} elsewhere.",
      "detailNowhere": "Nothing left in {{place}}, nor anywhere else."
    },
    "count_variance": {
      "title": "Count {{number}} differs by {{percent}}%",
      "detail_one": "The limit is {{limit}}%. {{count}} line differs, {{value}} TND in total.",
      "detail_other": "The limit is {{limit}}%. {{count}} lines differ, {{value}} TND in total."
    },
    "overstock": {
      "title": "{{product}} is above its maximum",
      "detail": "{{quantity}} in stock. The maximum for this location is {{max}}.",
      "detailTotal": "{{quantity}} in stock. The maximum is {{max}}."
    },
    "job_failed": {
      "backup": "The backup failed",
      "import": "An import failed",
      "detail": "It closes by itself after the next one succeeds."
    },
    "order_to_prepare": {
      "title": "Order {{number}} to prepare",
      "detail_one": "{{count}} line, waiting at this site. Open it to start.",
      "detail_other": "{{count}} lines, waiting at this site. Open it to start."
    },
    "cod_overdue": {
      "title": "Order {{number}}: the courier has not paid in",
      "detail_one": "Delivered {{count}} day ago, {{due}} TND expected. Record the courier’s settlement.",
      "detail_other": "Delivered {{count}} days ago, {{due}} TND expected. Record the courier’s settlement."
    },
    "shift_open_late": {
      "title": "{{register}}: shift still open",
      "detail": "{{cashier}}'s shift is open after the closing time ({{time}}). Count the drawer and close it."
    },
    "cash_variance": {
      "title": "{{register}}: a {{variance}} TND variance to approve",
      "detail": "{{cashier}} counted {{counted}} TND, {{expected}} TND expected. A manager approves it to close the shift."
    }
  },
  "resolution": {
    "cleared": "Closed automatically on {{date}}",
    "clearedBy": "Closed automatically when {{reference}} was validated",
    "read": "Closed when {{person}} read it, {{date}}",
    "decided": "Closed when {{reference}} was decided, {{date}}",
    "next_success": "Closed automatically after the next success, {{date}}"
  },
  "actions": {
    "openProduct": "Open product",
    "review": "Review",
    "receive": "Receive stock",
    "openTransfer": "Open transfer",
    "transfer": "Transfer",
    "reviewCount": "Review count",
    "openDataTools": "Open data tools",
    "openOrder": "Open order",
    "settleCod": "Record settlement",
    "openShift": "Open shift"
  },
  "how": {
    "title": "How you are notified",
    "bell": "In the app (bell)",
    "alwaysOn": "Always on",
    "email": "Email for each alert",
    "digest": "Daily summary email",
    "locations": "Locations covered",
    "all": "All",
    "on": "On",
    "off": "Off",
    "noEmail": "You have no email address yet: an administrator can add one to your account.",
    "change": "Change alert settings"
  },
  "meaning": {
    "title": "What each alert means",
    "low_stock": "Quantity is at or below the minimum, in total or in one location.",
    "out_of_stock": "Quantity is exactly zero.",
    "negative_stock": "Quantity went below zero after someone confirmed it.",
    "overstock": "Quantity is above the maximum.",
    "transfer_delayed_one": "Sent but not received after {{count}} day.",
    "transfer_delayed_other": "Sent but not received after {{count}} days.",
    "large_adjustment": "A correction is worth more than the approval limit ({{limit}} TND).",
    "count_variance": "A count differs by more than {{percent}}% of the expected value.",
    "job_failed": "An automatic job did not finish. Admins only.",
    "order_to_prepare": "An order was confirmed at your site: its stock is reserved and waits to be prepared.",
    "cod_overdue": "A cash on delivery order was delivered and the courier has not paid the money in within the days set in Configuration.",
    "shift_open_late": "A shift is still open after the closing time set in Configuration: its drawer has not been counted.",
    "cash_variance": "A closing count differs from the expected cash by more than the limit: a manager approves it before the Z report."
  },
  "bell": {
    "title": "Notifications",
    "unread_one": "{{count}} new alert",
    "unread_other": "{{count}} new alerts",
    "empty": "You are all caught up",
    "emptyText": "Nothing new since you last looked.",
    "seeAll": "See all alerts"
  }
}
